import { setConsoleFunction } from 'three';

const R3F_CLOCK_DEPRECATION = 'Clock: This module has been deprecated. Please use THREE.Timer instead.';

export function shouldSilenceThreeWarning(message: string): boolean {
  return message.includes(R3F_CLOCK_DEPRECATION);
}

let configured = false;

export function configureThreeLogging(): void {
  if (configured) {
    return;
  }

  configured = true;

  setConsoleFunction((type, message, ...params) => {
    if (type === 'warn' && shouldSilenceThreeWarning(message)) {
      return;
    }

    const consoleMethod =
      type === 'error' ? console.error : type === 'warn' ? console.warn : console.log;
    consoleMethod(message, ...params);
  });
}
